import { render, staticRenderFns } from "./OpenDetails.vue?vue&type=template&id=2ef67868&scoped=true"
import script from "./OpenDetails.vue?vue&type=script&lang=js"
export * from "./OpenDetails.vue?vue&type=script&lang=js"
import style0 from "./OpenDetails.vue?vue&type=style&index=0&id=2ef67868&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef67868",
  null
  
)

export default component.exports